/* eslint-disable no-param-reassign */
import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { StateStore } from '@bingads-webui/state-store';
import { withStateStore } from '@bingads-webui/with-state-store';
import { withScope } from '@bingads-webui-react/scope-service';
import { withGlobalFilter } from '@bingads-webui-campaign-react/global-filter-context';
import { StyledSubPageMenu, HistoryButton, AutoApplyButton } from '@bingads-webui-campaign-react/sub-page-menu';
import {
  withSiteMap,
  processorSet,
} from '@bingads-webui-campaign-react/with-site-map';
import { formatPercentOneDecimal } from '@bingads-webui-campaign/recommendation-core';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { StyledRecOptimizationOverallScore } from '@bingads-webui-campaign-react/recommendation-os-overall';
import { Activity, Scenario } from '@bingads-webui-react/hoc-with-signal';

export const recommendationDataStore = new StateStore({});

const WithSiteMapSubPageMenu = withSiteMap(
  React.memo(StyledSubPageMenu),
  processorSet.all
);

class RecommendationSubPageMenu extends React.Component {
  static defaultProps = {
    showDatePicker: false,
  };

  constructor(props) {
    super(props);
    this.renderCategoryOptimizationScore = this.renderCategoryOptimizationScore.bind(this);
    this.getTabItems = this.getTabItems.bind(this);
  }

  getTabItems(tabItems) {
    const categoryScoreUpLifts = this.props.store.state.categoryScoreUpLifts &&
      _.map(this.props.store.state.categoryScoreUpLifts, e =>
        ({ ScoreUpLift: e.ScoreUpLift, Category: e.Category.split(' ')[0] }));
    return _.map(tabItems, (item) => {
      const categoryScoreUpLift = _.findWhere(categoryScoreUpLifts, { Category: item.id });
      return _.extend(
        {},
        item,
        { scoreUpLift: categoryScoreUpLift && categoryScoreUpLift.ScoreUpLift }
      );
    });
  }

  changeLayout = (params) => {
    const { overallOptimizationScoreBar } = this.props.store.state;

    if (params.tab && params.tab.mode && !_.isEmpty(overallOptimizationScoreBar)) {
      params.tab.mode = 'optimizationScore';
    }

    this.props.changeLayout(params);
  }

  renderMainOptScore() {
    const {
      overallOptimizationScoreBar,
      renderDownloadButton,
      isAutoApplyRecommendationEnabled,
    } = this.props.store.state;

    return (
      <StyledRecOptimizationOverallScore
        overallOptimizationScoreBar={overallOptimizationScoreBar}
        renderAutoApplyButton={() => <AutoApplyButton />}
        renderDownloadButton={renderDownloadButton}
        renderHistoryButton={() => <HistoryButton />}
        i18n={this.props.i18n}
        scope={this.props.scope}
        isAsyncApplyEnabled={this.props.permissions.IsBAARecommendationsAsyncApplyEnabled}
        isAutoApplyRecommendationEnabled={isAutoApplyRecommendationEnabled}
        showDownloadButton={!this.props.scope.values.recommendationType}
      />
    );
  }

  renderCategoryOptimizationScore(categoryItem) {
    let categoryScore = '';

    if (categoryItem.scoreUpLift && categoryItem.scoreUpLift !== 0) {
      categoryScore = `+${formatPercentOneDecimal(categoryItem.scoreUpLift, this.props.i18n)}`;
    }

    return !_.isUndefined(categoryItem.scoreUpLift) && (
      <div className="category-score-upLift">{categoryScore}</div>
    );
  }

  render() {
    const { permissions, scope } = this.props;
    const {
      overallOptimizationScoreBar,
      categoryScoreUpLifts,
      renderDownloadButton,
      isAutoApplyRecommendationEnabled,
    } = this.props.store.state;

    return (
      <React.Fragment>
        {!_.isEmpty(overallOptimizationScoreBar) && renderDownloadButton && this.renderMainOptScore()}
        <Scenario name="sub-page-memu">
          <Activity name="recommendation-sub-page-memu">
            <WithSiteMapSubPageMenu
              {...this.props}
              changeLayout={this.changeLayout}
              forceResetLayout={this.props.available && this.props.isVisible}
              getTabItems={!_.isEmpty(overallOptimizationScoreBar) && !_.isEmpty(categoryScoreUpLifts) ? this.getTabItems : _.identity}
              renderExtraContent={this.renderCategoryOptimizationScore}
              renderDownloadButton={renderDownloadButton}
              showHistoryButton={_.isEmpty(overallOptimizationScoreBar) && permissions.IsBAARecommendationsAsyncApplyEnabled}
              showDownloadButton={_.isEmpty(overallOptimizationScoreBar) && !scope.values.recommendationType}
              showAutoApplyButton={_.isEmpty(overallOptimizationScoreBar) && isAutoApplyRecommendationEnabled}
            />
          </Activity>
        </Scenario>
      </React.Fragment>);
  }
}

export const StyledRecommendationSubPageMenu =
  withStateStore(withScope(withGlobalFilter(withI18nConsumer(RecommendationSubPageMenu))), recommendationDataStore);

RecommendationSubPageMenu.propTypes = {
  changeLayout: PropTypes.func.isRequired,
  available: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.object.isRequired,
    CurrentCustomer: PropTypes.object.isRequired,
    CurrentUser: PropTypes.object.isRequired,
    DecimalFormatter: PropTypes.object.isRequired,
    Token: PropTypes.string.isRequired,
  }).isRequired,
  showDatePicker: PropTypes.bool,
  siteMap: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      recommendationType: PropTypes.string,
    }).isRequired,
  }).isRequired,
  preferenceService: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  store: PropTypes.instanceOf(StateStore).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  permissions: PropTypes.shape({
    IsBAARecommendationsAsyncApplyEnabled: PropTypes.bool.isRequired,
  }).isRequired,
};
